<h1>{{ this.currentTitle }}</h1>

<app-division-selector [divisions]="divisions()" [selectedDivisionId]="selectedDivisionId" (divisionChanged)="onDivisionChange($event)"></app-division-selector>

<div size="tiny" [nbSpinner]="loading"
     nbSpinnerStatus="danger"
     nbSpinnerSize="large"
     nbSpinnerMessage="">
  <h2>{{ 'admin.groups.group' | translate }} A</h2>

  <app-standings-table [standingsList]="standingsGroupA()"></app-standings-table>

  <h2>{{ 'admin.groups.group' | translate }} B</h2>

  <app-standings-table [standingsList]="standingsGroupB()"></app-standings-table>

  @if(groups().length > 2) {
    <h2>{{ 'admin.groups.group' | translate }} C</h2>
    <app-standings-table [standingsList]="standingsGroupC()"></app-standings-table>
  }

  @if(groups().length > 3) {
    <h2>{{ 'admin.groups.group' | translate }} D</h2>
    <app-standings-table [standingsList]="standingsGroupD()"></app-standings-table>
  }
</div>
